import { useState, useCallback } from "react";
import type { FormData } from "../types";
import { INITIAL_FORM_DATA } from "../constants";

export const useEvaluationForm = (initialData?: Partial<FormData>) => {
  const [formData, setFormData] = useState<FormData>({
    ...INITIAL_FORM_DATA,
    ...initialData,
  });

  const updateField = useCallback((field: keyof FormData, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  const updateAllFields = useCallback((data: Partial<FormData>) => {
    setFormData((prev) => ({
      ...prev,
      ...data,
    }));
  }, []);

  const reset = useCallback(() => {
    setFormData(INITIAL_FORM_DATA);
  }, []);

  return {
    formData,
    setFormData,
    updateField,
    updateAllFields,
    reset,
  };
};
